import React from "react";

function Artist() {
    return(
        <div>
            <h1>YDNM Artist</h1>
        </div>
    );
}

export default Artist;